<template>
    <div class="maindiv">
      <div class="textsection centerthis">
        <div class="new-gala">   

          <h1>Rockcliff Museum Gala 2026</h1>

          <img class="galaimage" src="../../assets/RCM3.jpg" alt="View across the museum grounds from the roof top of the hall of aliances">
          
          <p class="first-paragraph">
            Rockcliff Museum Gala Number 5!! is Sept 12th and 13th from 10am to 10pm CST each day, at K 15/16 on 
            Independence, and you are All invited!! 
          </p>
  
          <p class="red">
            <u>There is One Rule that is Extremely Important for visiting the Museum. Please honor this rule:</u><br>
            The point of Rockcliff Museum is to showcase not the items, but the names of the people who made 
            this world. Each item is renamed with the name of the person who created it. You do not have to 
            examine the item to see the name - the items all have visible names on them. Please do NOT right-click 
            examine the items. Every time an item is examined, there is a chance the signature will fade forever, 
            and yours will replace it. We want to avoid that as much as we can, so please keep actual examination 
            to a minimum.
          </p>

          <p class="green"> 
            The Gala will run both the 12th and 13th from 10am to 10pm CST on Independence, at K 15/16 For 
            information about how to get there, where to park, and more, please go to the Museum Guide page. Everyone 
            can attend, including NFI. We have also have summoners this year, and the Albia Taxi Service will be running 
            from Freedom Market to the Museum and back.
          </p>

        <h4>The 5th Anniversary Event is upon us!</h4>    
        <p>It is time to put on your best, most outlandish, most colorful, most refined, most goofy, and/or most expensive 
          outfit and come hang out at Rockcliff Museum for the Gala! The main attraction is the Museum itself. Wander the 
          buildings and grounds and find memories around every corner. This is a place to remember that we are all here 
          together only for a moment, and that moment is beautiful. But…there are other things planned as well…</p>

        <h4>Scavenger Hunt!</h4>    
        <p>Everyone who attends can participate in the Scavenger Hunt this year. Each person will get a book with paper in 
          it created by Seriphina and Lisabet, a flask of dye made by Boppit and Carmenx, and a reed pen. Questions will be 
          announced the first day of the Gala, and will be posted on signs near both entrances.</p>
        
        <h4>Sermoning at the New Rockcliff Temple!</h4>   
        <p>Priests are no longer relegated to a 'patio' this year. There is now a Rockcliff Temple on the Museum Grounds 
          where you can hang out and have an incredible view of the surrounding area as well as the event itself. The Temple 
          provides one of the best views on deed. There will be food as well as saccing items for summoners, and of course 
          all 4 altars will be available. The Museum recognizes this as an opportunity for Priests to improve skills, and I 
          hope to see a global cast happen during the event!</p>
        
        <h4>Albia Taxi Service!</h4>  
        <p>Humongus will be running the Albia Taxi Service to help folks get to and from the Gala from the harbor and portal.</p>
        
        <h4>Give-Aways!</h4>
        <p>Kindrashae/Killashandra donated items made by Aaedean to give to folks. This is in keeping with his generosity. 
          Aaedean loved Wurm, and would love for folks to have and use some of his items. There are also items from Stormblade 
          imped by Uzetaab for those who want something with his signature.</p>

        <h4>Gala Statuettes!</h4>   
        <p>Camaril is making the Gala Statuettes again this year, and everyone who attends gets to take one home!</p>
        
        <h4>Auctions!</h4>
        <p>Folks have donated items for me to auction off for the deed token. I have never asked for a single auction item. 
          These items were brought over by folks who wanted to contribute to the Museum, and I thank them all for their 
          generosity.</p>

        <h4>The Rockcliff Workshop is Stocked With Mats!</h4> 
        <p>This is for Anyone from Any server who wants to make something with their signature for the Museum. The new NFI 
          Building is Complete! Folks in NFI can port over to attend the Gala. Supplies will be at the Museum Workshop and 
          ready for you to use, and staff can help you. Everyone in Wurm is valuable to the game. Everyone. The Museum was 
          built to honor that fact. Therefore, in order to include NFI, this is the solution available until/if/when the 
          servers merge. We are a community that is connected through global chat which means there are friends across the 
          SFI/NFI divide and here, there is no divide. Here we are all together just like in GL. All Wurmians belong here.</p>
          <p>There are clothes available to borrow. Cloth sets were made and dyed for Gala attendees whose items can't portal 
            over with them. </p>
        
        <h4>Accommodations! - Read to Reserve Rooms:</h4>
        <p>Uzetaab has expanded Fairview Harbor Inn down at the docks. It is a three-building Inn with individual entry rooms 
          each with a pasture for horses or wagons or carts right at your front door. There are 60 rooms, but visitors 
          wishing to stay during the Gala need to reserve their room ahead of time. PM Nirav to reserve a room. There is also 
          space available for free camping if you bring your own tent.</p>

          
        </div>


        <hr>
        <hr>
        <hr>
        &nbsp;<br>

        <h3>The Grand Opening took place Sat Sept 3rd, 2022</h3>
        <p>
          It was a glorious event with folks from all over the SFI and staff. <br>
          This was the forum post at <a href="https://forum.wurmonline.com/index.php?/topic/192098-rockcliff-museum-qa-details-about-the-grand-opening/">https://forum.wurmonline.com/index.php?/topic/192098-rockcliff-museum-qa-details-about-the-grand-opening/</a><br>
          Here are some images from that day: 
        </p>
        <div class="images">
          <img class="standard-size" src="../../assets/opening/od4 by Jacqulina.jpg" alt="Sea Monster">
          <img class="standard-size" src="../../assets/opening/od5 by Bunnbunnnn.jpeg" alt="view from the observation tower">
          <img class="standard-size" src="../../assets/opening/od3 by Jacqulina.jpg" alt="someone standing in a crate">
          <img class="standard-size" src="../../assets/opening/od5 by Jacqulina.jpg" alt="Reddragon's tavern">
          <img class="standard-size" src="../../assets/opening/od1by Lyhrinae.jpg" alt="memorial coffin with roses">
          <img class="standard-size" src="../../assets/opening/od6 by Kasumi.jpg" alt="View of the museum at night">
        </div>
       
        <h3>See you at the Gala in Sept 2026! </h3>
        <br> &nbsp; <br> 
      </div>
    </div>  
  </template>
  
  
  <script>
    export default {
      name: 'Gala2026'
    }
  </script>
  
  
  <style scoped>
  h1 {
    width: fit-content; 
    margin: 20px auto; 
    color: rgb(194, 2, 194);
  }
  .centerthis {
    width: fit-content; 
    margin: auto;
    width: 90%;
    margin: auto;
  }
  .new-gala {
    width: fit-content; 
    margin: 0 auto 60px auto; 
    text-align: center;
  }  
  .galaimage {
    width: 94%;
    max-width: 800px;
    border: 2px solid black;
    margin: 10px;
  }
  .secondimage {
    width: 75%;
    max-width: 500px;
    border: 2px solid black;
    margin: 10px;
  }
  .first-paragraph {
    color: blue; 
    font-size: 1.2em;
  }
  .red {
    color: red;
  }
  .purple {
    color: rgb(194, 2, 194);
    font-size: 1.2em;
  }
  .green {
    color: rgb(30, 194, 120);
    font-size: 1.2em;
  }
  .light-blue {
    color: rgb(30, 194, 255);
    font-size: 1.2em;
  }

  .images {
    width: 100%;
    align-content: center;
  }
  </style>